import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/app/set-rules.svg'


const _withScopeId = n => (_pushScopeId("data-v-c5c27a38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addRules" }
const _hoisted_2 = { class: "setRule" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "secondCheck" }
const _hoisted_5 = { class: "custom" }
const _hoisted_6 = { class: "week" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { style: {"padding":"0 20px","line-height":"34px"} }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = {
  key: 0,
  class: "allTime"
}
const _hoisted_12 = { class: "dsc" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "attension",
  src: _imports_0
}, null, -1))
const _hoisted_14 = { class: "oprate" }

import { defineComponent, ref, onMounted, computed, watch, nextTick } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getUnblockApp } from "@/api/devices";
import HourPicker from '@/views/appActivites/component/hourPicker.vue'; // 导入自定义组件的路径
import { numberToString, numberToWeek, calculateDuration, formatToTime, checkFormat } from "@/views/screen/component/fomat";
import { gaEvent } from "@/utils/format";


export default /*#__PURE__*/_defineComponent({
  __name: 'addBlock',
  props: {
  // 是否为新增
  isNew: {
    type: Boolean,
    default: true,
  },
  showData: {
    type: Object,
    default: {}
  }
},
  emits: ["closeAdd", 'close'],
  setup(__props, { emit: __emit }) {

const store = useStore();
const { t } = useI18n();
const id = computed(() => {
  return store.state.currentDeviceId;
});

const props = __props;

watch(() => props.isNew, (newV) => {
  if (!newV) {
    nextTick(() => {
      console.log('showData:', props.showData);
      cycle.value = props.showData.cycle
      block_start_time.value = props.showData.block_start_time
      block_end_time.value = props.showData.block_end_time
      status.value = props.showData.status

      console.log('111', props.showData.block_start_time);


      const getEditWeek = numberToString(props.showData.cycle)
      // console.log('aaaaa',aaa);
      selectedOptions.value = getEditWeek
      if (selectedOptions.value.length == weekOptions.length) {
        checkAll.value = true
      }

      const currentDate = new Date(); // 获取当前日期对象
      const startString = `${currentDate.toDateString()} ${props.showData.block_start_time}:00`; // 将时间字符串拼接到日期字符串中
      const endString = `${currentDate.toDateString()} ${props.showData.block_end_time}:00`; // 将时间字符串拼接到日期字符串中
      console.log('props.showData.block_start_time1', props.showData.block_start_time, props.showData.block_end_time);


      timeRange.value = [startString, endString]
      getTimeRange([props.showData.block_start_time, props.showData.block_end_time])
      const timeAll = calculateDuration(block_start_time.value, block_end_time.value)
      allTime.value = `${timeAll[0]}h${timeAll[1]}m`
      console.log('props.showData.block_start_time2', timeRange.value);
    })
  }
}, {
  immediate: true
})
const emit = __emit;
const cycle = ref(0b0)
const block_start_time = ref('')
const block_end_time = ref('')
const status = ref('')
const allTime = ref('')
const weekOptions = [
  {
    label: t('famikeep200.Every Monday'),
    value: 0b00100000
  },
  {
    label: t('famikeep200.Every Tuesday'),
    value: 0b00010000
  }, {
    label: t('famikeep200.Every Wednesday'),
    value: 0b00001000
  }, {
    label: t('famikeep200.Every Thursday'),
    value: 0b00000100
  }, {
    label: t('famikeep200.Every Friday'),
    value: 0b00000010
  }, {
    label: t('famikeep200.Every Saturday'),
    value: 0b00000001
  }, {
    label: t('famikeep200.Every Sunday'),
    value: 0b01000000
  },
]
const selectedOptions = ref([])
const checkAll = ref(false)
const isIndeterminate = ref(false)

// 下拉框选择事件
const handleSelect = (value: any) => {
  const checkedCount = value.length;
  checkAll.value = checkedCount === weekOptions.length;
  isIndeterminate.value = checkedCount > 0 && checkedCount < weekOptions.length;
  console.log("selectedOptions1：", selectedOptions.value);

}
// 全选事件
const handleCheckAllChange = (val: any) => {
  const data = weekOptions.map(item => {
    return item.label
  })
  console.log("val:", val);
  console.log("data:", data);
  console.log("selectedOptions2：", selectedOptions.value);

  selectedOptions.value = val ? data : [];
  isIndeterminate.value = false;
}

const selectedHour = ref()
// 获取选择的时间范围
const timeRange = ref([])

const getTimeRange = (timerange: []) => {
  console.log('timerange', timerange, selectedHour.value);
  timeRange.value = timerange
  const timeAll = calculateDuration(timeRange.value[0], timeRange.value[1])
  allTime.value = `${timeAll[0]}h${timeAll[1]}m`
  console.log('allTime', allTime.value);
}

const clearAllTime = () => {
  allTime.value = ""
}

const disableSave = ref(false)

const saveRule = () => {
  gaEvent("ScreenBlock_Save", {
    event_category: "ScreenBlock",
    event_label: 'None',
  });
  cycle.value = 0b0
  console.log('selectedOptions', selectedOptions.value, timeRange.value);
  selectedOptions.value.forEach((item: any) => {
    weekOptions.forEach((item2: any) => {
      // console.log('item2',item2,item);
      if (item2.label == item) {
        cycle.value = cycle.value + item2.value
        // console.log('cycle.value',cycle.value);
      }
    })
  })
  const getEditWeek = numberToWeek(cycle.value)
  // console.log('getEditWeek',getEditWeek,cycle.value);
  // console.log('getEditWeek1',cycle.value);
  gaEvent("ScreenBlock_Date", {
    event_category: "ScreenBlock",
    event_label: getEditWeek,
  });
  if (timeRange.value.length) {
    block_start_time.value = timeRange.value[0]
    block_end_time.value = timeRange.value[1]
  }

  gaEvent("ScreenBlock_Day", {
    event_category: "ScreenBlock",
    event_label: allTime.value,
  });

  emit('closeAdd', {
    'cycle': cycle.value,
    'block_start_time': checkFormat(block_start_time.value) ? formatToTime(block_start_time.value) : block_start_time.value,
    'block_end_time': checkFormat(block_end_time.value) ? formatToTime(block_end_time.value) : block_end_time.value,
    'status': 'on'
  })
}

const backTo = () => {
  gaEvent("ScreenBlock_Return", {
    event_category: "ScreenBlock",
    event_label: 'None',
  });
  emit('close')
}


return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("famikeep200.Set screen disable duration")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('famikeep200.Disable period')), 1),
            _createVNode(_component_el_select, {
              multiple: "",
              clearable: "",
              modelValue: selectedOptions.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOptions).value = $event)),
              placeholder: _unref(t)(`famikeep200.please choose`),
              onChange: handleSelect
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_checkbox, {
                    indeterminate: isIndeterminate.value,
                    modelValue: checkAll.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkAll).value = $event)),
                    onChange: handleCheckAllChange
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('famikeep200.Daily')), 1)
                    ]),
                    _: 1
                  }, 8, ["indeterminate", "modelValue"])
                ]),
                _createVNode(_component_el_checkbox_group, {
                  modelValue: selectedOptions.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOptions).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekOptions, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.label
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            style: {"pointer-events":"none"},
                            label: item.label
                          }, null, 8, ["label"])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('famikeep200.Time')), 1),
            _createVNode(HourPicker, {
              onEmitTimeRange: getTimeRange,
              timeRange: timeRange.value,
              onClearAllTime: clearAllTime
            }, null, 8, ["timeRange"])
          ]),
          (allTime.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(allTime.value) + _toDisplayString(_ctx.$t('famikeep200.Total')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('famikeep200.You can lift the disablement at any time')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", {
        class: "save opateBtn",
        onClick: saveRule
      }, _toDisplayString(_ctx.$t('famikeep200.Save')), 1),
      _createElementVNode("div", {
        class: "back opateBtn",
        onClick: backTo
      }, _toDisplayString(_ctx.$t('famikeep200.Back')), 1)
    ])
  ]))
}
}

})